<template>
  <div class="bb-proforma-wrapper">
    <transition name="fade" appear>
      <loader-fly v-if="loaderRun"/>
    </transition>
    <div class="bb-credit-note-proforma"
         ref="bbProforma"
         :class="{'bb-credit-note-proforma_hide': proformaCreditNoteSave}"
    >
      <div class="bb-credit-note-proforma-header">
        <div class="bb-credit-note-proforma-header-info">
          <div class="bb-credit-note-proforma-header-info-text"
          >
            <div>{{texts.info.info1}}</div>
            <div>{{texts.info.info2}}</div>
            <div>{{texts.info.info3}}</div>
            <a href="mailto:Accounting@uae-consulting.com">{{texts.info.info4}}</a>
            <a target="_blank" href="https://www.uae-consulting.com/">{{texts.info.info5}}</a>
            <div>{{texts.info.info6}}</div>
            <div>{{texts.info.info7}}</div>
          </div>
          <div class="bb-credit-note-proforma-header-title-wrapper__logo">
            <img :src="defaultLogo" />
          </div>

        </div>
        <div class="bb-credit-note-proforma-header-title-wrapper">
          <h1 class="bb-credit-note-proforma-header-title-wrapper__title">
            TAX CREDIT NOTE
          </h1>
        </div>
      </div>
      <div class="bb-credit-note-proforma-details">
        <div class="bb-credit-note-proforma-details-section">
          <div class="bb-credit-note-proforma-details-section__header
                      bb-credit-note-proforma-details-section__header_first"
          >
            CREDIT TO:
          </div>
          <div class="bb-credit-note-proforma-details-section-item bb-credit-note-proforma-details-section-item_ref">
            <div class="bb-credit-note-proforma-details-section-item__title">
              <span>Issued to:</span>
            </div>
            <div class="bb-credit-note-proforma-details-section-item-client-info"
                 v-click-outside="issuedOpenEdit"
            >
              <div :contenteditable="issuedToEditable"
                   @input="onInputIssued"
                   v-autofocus
                   :class="{'bb-credit-note-proforma-details-section-item-client-info__name_border': issuedToEditable}"
                   class="bb-credit-note-proforma-details-section-item-client-info__name"
                   id="info-name"
              >
                <pre>{{issuedTo}}</pre>
              </div>
              <img src="@/assets/images/icon-pencil.png"
                   @click.stop="issuedOpenEdit(true)"
                   v-if="!viewMode"
                   class="bb-credit-note-proforma-details-section-item-client-info__edit"/>
            </div>
          </div>
          <div class="bb-credit-note-proforma-details-section-item">
            <div class="bb-credit-note-proforma-details-section-item__title">
              Description:
            </div>
            <div>
              Tax Credit Note issued against <br/> {{creditNoteDescription}}
            </div>
          </div>
          <div class="bb-credit-note-proforma-details-section-item
                      bb-credit-note-proforma-details-section-item_top"
               v-if="(!hideForPdf && !viewMode) || noteDescription"
          >
            <div class="bb-credit-note-proforma-details-section-item__title">
              Note:
            </div>
            <textarea v-if="!hideForPdf && !viewMode" class="bb-input
                             bb-input_border
                             bb-credit-note-proforma-details-section-item__textarea"
                      v-model="noteDescription"/>
            <div v-else
                 class="bb-credit-note-proforma-header__description"
            >
              {{noteDescription}}
            </div>
          </div>
        </div>
        <div class="bb-credit-note-proforma-details-section">
          <div class="bb-credit-note-proforma-details-section__header
                      bb-credit-note-proforma-details-section__header_last"
          >
            TAX CREDIT NO. {{creditNoteNo}}
          </div>
          <div class="bb-credit-note-proforma-details-section-item
                      bb-credit-note-proforma-details-section-item_ref"
          >
            <div class="bb-credit-note-proforma-details-section-item__title">
              Tax Credit Note No:
            </div>
            <div class="bb-credit-note-proforma-details-section-item-client-info">
              {{creditNoteNo}}
            </div>
          </div>
          <div class="bb-credit-note-proforma-details-section_date">
            <div class="bb-credit-note-proforma-details-section-item">
              <div class="bb-credit-note-proforma-details-section-item__title
                          bb-credit-note-proforma-details-section-item__title_center"
              >
                Issued on:
              </div>
              <DataPicker @setDate="setIssueDate"
                          :value="dates.issue"
                          :defaultDate="dates.issue"
                          styles="proforma"
                          :class="{'bb-credit-note-proforma-details-section-item_event': viewMode}"
                          :hide-ico="proformaCreditNoteSave"/>
            </div>
          </div>
        </div>
      </div>
      <div class="bb-credit-note-proforma-service-list">
        <div class="bb-credit-note-proforma-service-list-row bb-credit-note-proforma-service-list-row_header"
             :class="{'bb-credit-note-proforma-service-list-row_pdf': hideForPdf}"
        >
          <div>No.</div>
          <div>SERVICE{{space}}DESCRIPTION</div>
          <div class="bb-credit-note-proforma-service-list-row__center">INVOICED (EXCL)</div>
          <div class="bb-credit-note-proforma-service-list-row__center">ACTUAL (EXCL)</div>
          <div class="bb-credit-note-proforma-service-list-row__center">DIFFERENCE (EXCL)</div>
          <div class="bb-credit-note-proforma-service-list-row__center">VAT RATE</div>
          <div class="bb-credit-note-proforma-service-list-row__center">VAT AMOUNT</div>
          <div class="bb-credit-note-proforma-service-list-row__center">TOTAL AMOUNT (INCL)</div>
          <div v-if="!hideForPdf && !viewMode"><!-- toolbar --></div>
        </div>
        <div class="bb-credit-note-proforma-service-list-row"
             :class="{'bb-credit-note-proforma-service-list-row_pdf': hideForPdf}"
             v-for="(service, index) in services"
             :key="service._id"
        >
          <!-- index -->
          <div class="bb-credit-note-proforma-service-list-row__index">{{index + 1}}</div>
          <!-- activity -->
          <div class="bb-credit-note-proforma-service-list-row__name">
            <span class="bb-credit-note-proforma-service-list-row__index_bold">
              {{getNameCategory(service)}}
            </span>
            {{service.name}}
          </div>
          <!-- invoiced -->
          <div class="bb-credit-note-proforma-service-list-row__center
                      bb-credit-note-proforma-service-list-row__amount"
          >
            {{numeralConvertNumber(service.invoiced)}}
          </div>
          <!-- actual -->
          <div class="bb-credit-note-proforma-service-list-row__center
                      bb-credit-note-proforma-service-list-row__amount"
          >
            {{service.actual}}
          </div>
          <!-- difference -->
          <div class="bb-credit-note-proforma-service-list-row__center">
            {{numeralConvertNumber(service.difference)}}
          </div>
          <!-- vatRate -->
          <div class="bb-credit-note-proforma-service-list-row__center">
            {{service.vatRate}}
          </div>
          <!-- vatAmount -->
          <div class="bb-credit-note-proforma-service-list-row__center">
            {{numeralConvertNumber(service.vatAmount)}}
          </div>
          <!-- totalAmount -->
          <div class="bb-credit-note-proforma-service-list-row__center">
            {{numeralConvertNumber(service.totalAmount)}}
          </div>
          <div v-if="!hideForPdf && !viewMode">
            <Toolbar :index="index"
                     :no-edit="true"
                     :delete-index="deleteConfirmIndex"
                     @deleteOpen="deleteConfirmIndex = index"
                     @deleteClose=" deleteConfirmIndex = false"
                     @deleteItem="deleteService(index, service._id)"
                     :item="service"/>
          </div>
        </div>
      </div>
      <div class="bb-credit-note-proforma-total">
        <div class="bb-credit-note-proforma-total-calculations">
          <div class="bb-credit-note-proforma-total-calculations__totals">
            <div class="bb-credit-note-proforma-total-calculations__row
                        bb-credit-note-proforma-total-calculations__row_vat"
            >
              <span>SUBTOTAL:</span>
              <span class="bb-credit-note-proforma-total-calculations__row_item">
                <span>AED</span>
                <span>{{numeralConvertNumber(subTotal())}}</span>
              </span>
            </div>
            <div class="bb-credit-note-proforma-total-calculations__row
                      bb-credit-note-proforma-total-calculations__row_vat"
            >
              <span>INCLUDES TAX:</span>
              <span class="bb-credit-note-proforma-total-calculations__row_item">
                <span>AED</span>
                <span>{{numeralConvertNumber(includesTax())}}</span>
              </span>
            </div>
            <div class="bb-credit-note-proforma-total-calculations__row
                        bb-credit-note-proforma-total-calculations__row_accent
                        bb-credit-note-proforma-total-calculations__row_total"
            >
              <span>TOTAL CREDIT:</span>
              <span class="bb-credit-note-proforma-total-calculations__row_item">
                <span>AED</span>
                <span>{{numeralConvertNumber(subTotal() + includesTax())}}</span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="bb-credit-note-proforma-footer">
        <div class="bb-credit-note-proforma-footer__row">
          Thank you for your trust in our services. We value your business.
        </div>
        <div>
          <div>{{texts.details.row1}}</div>
          <div>{{texts.details.row2}}</div>
          <div>{{texts.details.row3}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import defaultLogo from '@/assets/images/logo.png'
import SoaCreditNote from '@/api/SoaCreditNote/api'
import '@/assets/fonts/fontsPdf/ArialBold-bold'
import '@/assets/fonts/fontsPdf/ArialRegular-normal'
import convertNumber from '@/mixin/convertNumber'
import DataPicker from '@/components/Main/DataPicker/DataPicker'
import Toolbar from '@/components/Main/Toolbar/Toolbar'
import JsPdf from 'jspdf'
import {find, get} from 'lodash'
import {contactType} from '@/constants/clientInfo'
import serviceCategoriesList from '@/mixin/serviceCategoriesList'
import moment from 'moment'
import numeral from 'numeral'

export default {
  name: 'CreditNoteProforma',
  props: ['invoiceId', 'viewMode', 'editableSoaCreditNote'],
  components: {
    LoaderFly,
    Toolbar,
    DataPicker
  },
  computed: {
    serviceCategories: {
      get: function () {
        return this.$store.getters.serviceCategories
      },
      set: function (data) {
        this.$store.dispatch('setServiceCategories', data)
      }
    },
    total () {
      const received = get(this.soaCreditNotes, 'received', 0)
      const toBePaid = get(this.soaCreditNotes, 'toBePaid', 0)
      const totalInvoicedAed = get(this.soaCreditNotes, 'totalInvoicedAed', 0)
      const amount = (received - totalInvoicedAed) + toBePaid
      return this.numeralConvertNumber(amount)
    }
  },
  mixins: [convertNumber, serviceCategoriesList],
  data () {
    return {
      loaderRun: false,
      defaultLogo: defaultLogo,
      contactType: contactType,
      issuedTo: false,
      noteChange: '',
      hideForPdf: false,
      client: {},
      creditNoteNo: '',
      issuedToEditable: false,
      deleteConfirmIndex: false,
      issuedToChange: false,
      space: String.fromCharCode(160),
      received: 0,
      creditNoteDescription: '',
      noteDescription: '',
      soaCreditNotes: {},
      services: [],
      proformaCreditNoteSave: false,
      dates: {
        issue: new Date()
      },
      texts: {
        header: 'This is a tax credit note',
        info: {
          info1: 'Business Boutique DMCC ',
          info2: 'Office 2404, Saba 1 Tower, Cluster E',
          info3: 'Dubai, UAE 337151 AE',
          info4: 'Accounting@uae-consulting.com',
          info5: 'www.uae-consulting.com',
          info6: 'VAT_CUSTOM Registration NO.:',
          info7: '100042918100003'
        },
        conditions: {
          text: 'The amount is payable in full in advance into Business Boutique’s bank account.',
          accent: 'Dear Customer, kindly be advised that current invoice shall be ' +
            'considered paid only when the full amount is credited. ' +
            'Please, make sure that all related transfer charges are covered by the sender.'
        },
        details: {
          row1: 'Business Boutique DMCC | License No. DMCC-233817 | Office 2404 | Saba 1 Tower | Cluster E',
          row2: 'Dubai, UAE | Tel. +971 4 368 48 84 | Email: uae@uae-consulting.com',
          row3: 'Business Boutique DMCC is registered and licensed ' +
            'as a freezone company under the rules & regulations of DMCC.'
        }
      }
    }
  },
  methods: {
    onInputIssued (e) {
      this.issuedToChange = e.target.innerText
    },
    issuedOpenEdit (data) {
      data !== true ? this.issuedToEditable = false : this.issuedToEditable = true
      const div = document.getElementById('info-name')
      setTimeout(() => {
        if (div[0]) div[0].focus()
      }, 0)
    },
    subTotal () {
      return this.services.reduce((sum, item) => {
        sum += item.difference
        return sum
      }, 0)
    },
    includesTax () {
      return this.services.reduce((sum, item) => {
        sum += item.vatAmount
        return sum
      }, 0)
    },
    getCreditNoteDescription () {
      const taxInvoiceNumber = get(this.soaCreditNotes, 'taxInvoiceNumber', '')
      this.creditNoteDescription = `Tax Inv. ${taxInvoiceNumber}`
    },
    getCreditNoteNo () {
      const currentYear = moment().format('YYYY')
      const counter = numeral(this.soaCreditNotes.creditNoteCounter).format('000')
      this.creditNoteNo = `CN/${currentYear}/BB-${counter}`
    },
    generatePdf () {
      this.loaderRun = true
      let contentHtml = document.getElementsByClassName('bb-credit-note-proforma')[0].cloneNode(true)
      let dpi = document.createElement('div')
      dpi.style.width = '1cm'
      dpi.style.height = '1cm'
      dpi.style.position = 'fixed'
      dpi.style.top = '-100%'
      dpi.style.left = '-100%'
      dpi.style.zIndex = '-1'
      document.body.appendChild(dpi)
      const maxHeightA4 = 27 * dpi.clientHeight * 0.8
      contentHtml.style.position = 'fixed'
      contentHtml.style.top = '0'
      contentHtml.style.left = '0'
      contentHtml.style.padding = '1cm'
      contentHtml.style.width = '19cm'
      contentHtml.style.zIndex = -1
      contentHtml.style.minHeight = '257mm'
      contentHtml.style.transform = 'scale(0.85)'
      contentHtml.style.transformOrigin = 'top center'
      contentHtml.classList.add('bb-credit-note-proforma')
      contentHtml.classList.add('bb-credit-note-proforma_hide')
      const fileName = this.creditNoteNo
      document.body.appendChild(contentHtml)
      if (contentHtml.clientHeight > maxHeightA4) {
        let i = 85
        while (i > 2 && (contentHtml.clientHeight * (i * 0.01)) > maxHeightA4) {
          contentHtml.style.transform = `scale(0.${i})`
          i--
        }
      }
      const convertPdf = {
        orientation: 'p',
        unit: 'pt',
        format: 'a4',
        putOnlyUsedFonts: true,
        compress: true,
        filters: ['ASCIIHexEncode']
      }
      const doc = new JsPdf(convertPdf)
      doc.html(contentHtml, {
        callback: (pdf) => {
          pdf.deletePage(2)
          pdf.save(fileName)
          dpi.remove()
          contentHtml.remove()
          this.loaderRun = false
          this.$emit('close', true)
        },
        x: -60
      })
    },
    setIssueDate (date) {
      this.dates.issue = date
    },
    downLoadCreditNoteProforma () {
      this.hideForPdf = true
      this.proformaCreditNoteSave = true
      this.$nextTick(this.generatePdf)
    },
    createCreditNote () {
      this.hideForPdf = true
      this.loaderRun = true
      const body = {
        client: this.$route.params.id,
        number: this.creditNoteNo,
        invoice: this.soaCreditNotes._id,
        date: this.dates.issue,
        description: this.creditNoteDescription,
        balance: this.subTotal() + this.includesTax(),
        noteDescription: this.noteDescription,
        issueTo: this.issuedToChange,
        soaCreditNoteServices: this.services,
        subtotal: this.subTotal(),
        includeTax: this.includesTax(),
        totalCredit: this.subTotal() + this.includesTax(),
        received: this.received
      }
      SoaCreditNote.createSoaCreditNote(body)
        .then((resp) => {
          this.loaderRun = false
          this.proformaCreditNoteSave = true
          this.generatePdf()
          this.$emit('updateCreditNotes')
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    cancelProforma () {
      this.$emit('close')
    },
    setIssuedTo () {
      this.issuedTo = this.client.firstName + ' ' + this.client.lastName
      this.issuedToChange = this.issuedTo
    },
    deleteService (index, id) {
      this.deleteConfirmIndex = false
      this.$delete(this.services, index)
    },
    getNameCategory (row) {
      const category = get(row, 'category', 0)
      this.serviceCategories = this.serviceCategoriesList
      const res = find(this.serviceCategories, item => item.id === category)
      return res ? res.name : ''
    },
    activeViewMode () {
      let contentHtml = document.getElementsByClassName('bb-credit-note-proforma')[0]
      contentHtml.classList.add('bb-credit-note-proforma')
      contentHtml.classList.add('bb-credit-note-proforma_hide-proforma')
    },
    getSoaCreditNotes () {
      if (this.viewMode) return
      this.loaderRun = true
      const invoiceId = this.invoiceId
      SoaCreditNote.generateCreditNotes(invoiceId)
        .then(({data: {client, received, ...creditNoteData}}) => {
          this.loaderRun = false
          this.received = received
          this.soaCreditNotes = creditNoteData
          this.services = this.soaCreditNotes.invoiceservices.map(item => item)
          this.client = client
          this.setIssuedTo()
          this.getCreditNoteDescription()
          this.getCreditNoteNo()
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    }
  },
  mounted () {
    if (this.viewMode) {
      this.activeViewMode()
    }
  },
  beforeMount () {
    if (this.editableSoaCreditNote) {
      this.issuedTo = get(this.editableSoaCreditNote, 'issueTo', '')
      this.creditNoteDescription = get(this.editableSoaCreditNote, 'description', '')
      this.creditNoteNo = get(this.editableSoaCreditNote, 'number', '')
      this.services = get(this.editableSoaCreditNote, 'soaCreditNoteServices', [])
      this.noteDescription = get(this.editableSoaCreditNote, 'noteDescription', '')
      this.dates.issue = new Date(this.editableSoaCreditNote.date)
      return
    }
    this.getSoaCreditNotes()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../../sass/variables";
  @import "../../../../../../sass/mixins";

  .bb-proforma-wrapper {
    margin: auto;
    min-width: 100%;
  }

  .bb-credit-note-proforma {
    @include global-font;
    background: $color-white;
    border-radius: 5px;

    &-header {
      margin-bottom: 16px;

      &-info {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;

        &-text {
          display: grid;
          font-size: 13px;
          grid-gap: 10px;
        }
      }

      &__description {
        max-width: 270px;
        width: 100%;
        word-break: break-word;
      }

      &-title-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 40px;

        &__logo {
          width: 100px;
          height: 100px;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }

        }

        &__title {
          font-size: 45px;
          font-weight: 600;
          line-height: 53px;
        }
      }

      &__note {
        margin-top: 6px;
        text-align: center;
        font-size: 13px;
        line-height: 15px;
      }
    }

    &-details {
      display: flex;

      &-section {
        display: flex;
        flex-direction: column;
        position: relative;
        width: 100%;
        margin: 0 -1px;

        &__header {
          display: flex;
          align-items: center;
          background: $color-guardsman-red;
          height: 38px;
          color: $color-white;
          font-size: 14px;
          line-height: 17px;
          font-weight: 500;
          padding-left: 17px;
          margin-bottom: 13px;
          white-space: nowrap;

          &_first {
            border-radius: 5px 0 0 5px;
          }

          &_last {
            border-radius: 0 5px 5px 0;
          }
        }

        &_date {
          margin-top: 0;
        }

        &-item {
          padding-left: 17px;
          display: flex;
          font-size: 13px;
          line-height: 17px;
          margin-bottom: 11px;
          z-index: 12;

          &_event {
            pointer-events: none;
          }

          &_top {
            padding-top: 20px;
            padding-bottom: 20px;
          }

          &_ref {
            margin-bottom: 15px;
            min-height: 50px;
          }

          &__textarea {
            resize: none;
            width: 100%;
            font-size: 12px;
            height: 52px;
            position: relative;
            bottom: 9px;
            right: 15px;
            z-index: -1;
          }

          &__title {
            min-width: 130px;
            font-weight: 700;

            &_center {
              align-self: center;
            }

            &_start {
              align-self: flex-start;
            }
          }

          &-client-info {
            position: relative;
            width: 100%;

            &__edit {
              position: absolute;
              left: 81%;
              top: 0;
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 50%;
              font-size: 10px;
              width: 21px;
              height: 21px;
              cursor: pointer;
              user-select: none;
            }

            &__name {
              width: 80%;
              max-width: 325px;
              margin-bottom: 7px;
              height: auto;
              line-height: 26px;
              border: 1px solid transparent;

              &_border {
                border: 1px solid $color-wild-sand;
                box-sizing: border-box;
                border-radius: 5px;
              }

              pre {
                white-space: pre-line;
                line-height: 17px;
              }
            }
          }
        }
      }
    }

    &-service-list {
      &-row {
        display: grid;
        grid-template-columns: 15px 210px 70px 70px 70px 50px 60px 170px 10px;
        grid-gap: 17px;
        align-items: center;
        justify-content: space-between;
        padding: 8px 17px;
        font-size: 13px;
        line-height: 14px;

        &__wrap {
          display: grid;
          grid-template-columns: 60px auto;
        }

        &_expire {
          grid-template-rows: 1fr 1fr;
          grid-gap: 6px 17px;
        }

        &_header {
          padding: 12px 17px;
          color: $color-white;
          font-size: 14px;
          line-height: 16px;
          font-weight: 500;
          background: $color-guardsman-red;
          border-radius: 5px;
          margin-bottom: 10px;
        }

        &__end {
          display: inline-flex;
          justify-content: flex-end;
          text-align: center;
        }

        &__center {
          display: inline-flex;
          justify-content: center;
          text-align: center;
        }

        &__extra-icon {
          width: 21px;
          height: 21px;
          font-size: 21px;
        }

        &__amount {
          position: relative;
        }

        &-extra {
          display: grid;
          grid-template-columns: 1fr 1fr;
          grid-gap: 10px;

          &-item {
            position: relative;
            display: grid;
            align-items: center;
            justify-content: center;

            &__title {
              position: absolute;
              top: -15px;
              left: 0;
              width: 100%;
              font-size: 10px;
              color: $color-dusty-gray;
              text-align: center;
            }
          }
        }

        &__index {
          font-weight: 500;

          &_bold {
            font-weight: bold;
          }
        }

        &__name {
          word-break: break-word;
        }

        &-expire {
          display: grid;
          align-items: center;
          grid-template-columns: auto 1fr;
          grid-template-rows: 1fr;
          grid-gap: 6px;
          height: 32px;
          width: 100%;
          max-width: 350px;
          margin-right: 17px;

          &_include {
            grid-template-columns: 150px 14px;
            user-select: none;
            cursor: pointer;
          }

          &__checkbox {
            pointer-events: none;
          }

          &-container {
            grid-column: 2/9;
            display: flex;
            align-items: center;
            justify-content: start;
          }

          &__label {
            font-weight: 500;
            line-height: 14px;
            transition: 0.3s;

            &_include {
              &:hover {
                opacity: 0.7;
              }
            }
          }

          &__no-entries {
            color: $color-guardsman-red;
          }
        }

        &__input {
          display: block;
          width: 100%;
          box-sizing: border-box;
          border-radius: 2px;
          padding: 3px 6px;
          border: 1px solid $color-wild-sand;

          &:disabled {
            border-color: transparent;
          }

          &_center {
            text-align: center;
            background-color: transparent;
            color: $color-black;
          }
        }

        &-discount {
          display: grid;
          grid-template-columns: 21px 30px 10px;
          align-items: center;
          grid-gap: 5px;

          &__icon {
            color: $color-silver;
            font-size: 13px;
          }
        }

        &_pdf {
          grid-template-columns: 15px 1fr 50px 50px 57px 27px 47px 37px;
          grid-gap: 10px;
          font-size: 9px;

          &__input {
            border-color: transparent;
          }
        }
      }
    }

    &-total {
      display: flex;
      justify-content: flex-end;
      margin-top: 24px;

      &-terms {
        max-width: 275px;
        font-size: 13px;
        line-height: 15px;

        &__title {
          margin-bottom: 5px;
          font-size: 14px;
          line-height: 18px;
        }
      }

      &-calculations {
        display: flex;
        flex-direction: column;
        width: 325px;
        min-height: 169px;
        padding: 14px 20px;
        margin-left: 12px;
        box-sizing: border-box;
        border-radius: 6px;

        &__totals {
          border: 1px solid $color-wild-sand;
          padding: 14px 20px;
          margin: 0 -20px;
          box-sizing: border-box;
          border-radius: 6px;
        }

        &__row {
          display: flex;
          justify-content: space-between;
          font-size: 13px;
          font-weight: 700;
          line-height: 16px;
          margin-bottom: 15px;

          &_additional {
            min-height: 24px;
          }

          &_view {
            cursor: pointer;

            &:hover {
              opacity: 0.6;
            }
          }

          &_old {
            opacity: 0.5;
          }

          &_accent {
            color: $color-guardsman-red;
          }

          &__applied {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: -8px;
            height: 24px;

            &_old {
              height: auto;
            }

            &_input {
              @include global-font;
              margin-left: 5px;
              font-size: 13px;
              height: 100%;
              max-width: 68px;
              text-align: center;
              padding: 5px 4px;
            }
          }

          &_overpaid {
            color: $color-japanese-laurel;
          }

          &_underpaid {
            color: $color-pomegranate;
          }

          &:last-child {
            margin-bottom: 0;
          }

          &_vat {
            font-size: 13px;
            font-weight: normal;
            line-height: 15px;
          }

          &_item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            max-width: 100px;
            width: 100%;
          }

          &_total {
            margin-bottom: 8px;
          }
        }
      }
    }

    &-footer {
      width: 100%;
      font-size: 13px;
      line-height: 15px;
      text-align: center;

      &__row {
        margin-bottom: 18px;
      }
    }

    &__text-accent {
      color: $color-crimson;
    }

    &__header-credit-note {
      color: $color-guardsman-red
    }

    &_hide {
      &, * {
        font-family: 'Arial' !important;
      }

      .bb-credit-note-proforma {
        &-header {
          &__note {
            font-size: 11px;
          }

          &-info-text {
            font-size: 9px;
          }

          &-title-wrapper__title {
            font-size: 30px;
          }

          &-title-wrapper__logo {
            padding: 1px;
            width: 70px;
            height: 70px;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
        }

        &-details {
          &-section-item-client-info__name_border {
            border: 1px solid transparent;
          }

          &-section-item-client-info__edit {
            display: none;
          }

          &-section {
            &-item {
              font-size: 9px;
              margin-bottom: 13px;

              &_top {
                padding-top: 14px;
                padding-bottom: 0;
              }

              &_ref {
                margin-bottom: -20px;
              }

              &__textarea {
                border: none;
                background-color: transparent;
                font-size: 9px;
              }
            }
          }
        }

        &-total {
          &-terms {
            max-width: 269px;
            font-size: 11px;

            &__title {
              font-size: 13px;
            }
          }

          &-calculations {
            &__row {
              font-size: 9px;
              margin-bottom: 9px;

              &_hide {
                display: none;
              }
            }
          }
        }

        &-footer {
          font-size: 11px;
          position: absolute;
          bottom: 0.2cm;
          left: 50%;
          transform: translateX(-50%);

          &__row {
            margin-bottom: 10px;
          }
        }

        &-details-section__header,
        &-services-section__header {
          font-size: 9px;

          i {
            font-size: 10px;
          }
        }

        &-services-section-extra__icon {
          display: none;
        }

        &-services-section_total {
          div {
            padding-right: 17px;
            border-radius: 0 5px 5px 0;
          }
        }

        &-services-section-item__input {
          border: none;

          &:disabled {
            font: inherit;
            color: inherit;
            background-color: transparent;
          }
        }

        &-services-section_discount,
        &__button {
          display: none;
        }
      }
    }
  }
</style>

<style lang="scss">
.bb-credit-note-proforma_hide {
  .bb-data-picker {
    &__date {
      font-size: 9px !important;
    }
  }

  .bb-data-picker__icon {
    display: none !important;
  }
}

.bb-credit-note-proforma_hide-proforma {
  .bb-data-picker__icon {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/CreditNoteProforma.vue